import { render } from "./GivingNewRegular.vue?vue&type=template&id=54ac57e0&scoped=true"
import script from "./GivingNewRegular.vue?vue&type=script&lang=js"
export * from "./GivingNewRegular.vue?vue&type=script&lang=js"

import "./GivingNewRegular.vue?vue&type=style&index=0&id=54ac57e0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ac57e0"]])

export default __exports__